"use client";

import { deleteEvent } from "@/api";
import { appState } from "@/app/appState";
import { chatState } from "@/app/chatState";
import { usePathParam, useLocalNumberList } from "@/components/path-params";
import { EntryList } from "@/components/UI/tools";
import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { PageBox } from "@/components/UI/page";

const EventsList = observer(() => {
    const [loading, setLoading] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [eventSearch, setEventSearch] = useState<string>("");
    const [id, setId] = usePathParam("events");
    const [ids, setIds] = useState<number[]>([]);

    const deleteSelectedEvents = async () => {
        setDeleting(true);
        try {
            for (const eventId of ids) {
                await deleteEvent({ body: { id: eventId } });
            }
            appState.events = appState.events.filter((x) => !ids.includes(x.id));
            chatState.forgetDeletedObjects(ids.map((id) => ({ type: "event", id })));
            setIds([]);
        } catch {
            appState.setModal({ title: appState.t("common.error"), body: appState.t("objects.errorDeleteEvents") });
        } finally {
            setDeleting(false);
        }
    };

    useEffect(() => {
        appState.getEvents({ pageNumber: 0, search: eventSearch });
    }, [id, eventSearch]);

    return (
        <PageBox onScrollToBottom={() => appState.getEvents({ pageNumber: appState.events_page + 1, search: eventSearch })}>
            <div id="event" className="h-full w-full">
                <EntryList
                    name={appState.t("objects.list.event")}
                    readonly={![4, 5, 6, 7].includes(appState.user?.active_organisation.permission_type ?? 0)}
                    loading={loading}
                    deleting={deleting}
                    search={{ get: eventSearch, set: setEventSearch }}
                    deleteEntries={deleteSelectedEvents}
                    idParams={{
                        singular: { get: id, set: setId },
                        plural: { get: ids, set: setIds },
                    }}
                    items={appState.events?.map((x) => {
                        return {
                            id: x.id,
                            lock: x.user_lock ? !(x.user_lock === appState.user?.id) : false,
                            val: x.title + (x.tag_name ? ` [${x.tag_name}]` : ""),
                            readonly: false,
                            showonly: false,
                        };
                    })}
                />
            </div>
        </PageBox>
    );
});

export default EventsList;
